import { FormVue } from "./index.js";

(window as any).FormVueModal = FormVue;

export { FormVue };
export { openModal, closeModal } from "./modal.js";
export type { FormVueModalOptions } from "../shared/schema-types.js";
export type { ModalConfig, EmbedContext } from "../shared/types.js";
